import { ComponentStyleConfig } from '@chakra-ui/react'

export const switchStyles: ComponentStyleConfig = {
  parts: ['container', 'track', 'thumb'],
  variants: {
    'v2-dark': {
      thumb: {
        bg: '#002233',
      },
      track: {
        bg: '#264B5B',
        _checked: {
          bg: '#DDFE55',
        },
      },
    },
    'v2-light': {
      thumb: {
        bg: '#FFFFFF',
      },
      track: {
        bg: '#931100',
        _checked: {
          bg: '#2fb2b0',
        },
      },
    },
  },
}
